import { EMcsName } from '../../utils';

const USER_ENDPOINT_BASE = 'v1/customer';

export const GET_USER_INFO_CONF = {
  base: `${USER_ENDPOINT_BASE}/get-info`,
  mcsName: EMcsName.USER,
  access: 'private',
};
